import React, {useState} from "react" ;

import AppSidebarMenuItem from "../../Common/Sidebar/AppSidebarMenuItem";
import AppSidebarGroup from "../../Common/Sidebar/AppSidebarGroup";
import {getDashboardRouterLink, getTeamRouterLink, getUsersRouterLink} from "root/Wieldy/routePaths";
import ScrollRails from "root/Wieldy/ApplicationModules/Common/Body/ScrollRails";
import AppSidebarHeader from "root/Wieldy/ApplicationModules/Common/Sidebar/AppSidebarHeader";
import {useLocation} from "react-router-dom";
import queryString from "query-string";
import {OrgDashboardFilters} from "root/DataFunctions/Constants";
import phpVars from 'phpVars';

const OrgDashAppSidebar= (props) =>
{
    const {search} = useLocation();
    const queryParams = queryString.parse(search);

    const has_lifestory = phpVars.has_lifestory === 1 ? true :false;
    const defaultFilter =  has_lifestory ? OrgDashboardFilters.CHILD_POSTS  : OrgDashboardFilters.CHILD_MESSAGES
    const org_dashboard_filter = queryParams.type === undefined ? defaultFilter : queryParams.type;

    return (
        <div className="dt-module__sidebar">

            <AppSidebarHeader iconName={props.iconName} title={props.title} />

            <div className="dt-module__sidebar-content ps-custom-scrollbar ps" style={{height: props.height}}>

                <ul className="dt-module-side-nav">
                    <AppSidebarGroup title='Dashboard' default={org_dashboard_filter}>
                        {has_lifestory && <AppSidebarMenuItem link={getDashboardRouterLink('?type=child-posts')} title='Child Posts' name={OrgDashboardFilters.CHILD_POSTS} iconName='icon-chat' />}
                        {has_lifestory && <AppSidebarMenuItem link={getDashboardRouterLink('?type=staff-posts')} title='Staff Posts' name={OrgDashboardFilters.STAFF_POSTS} iconName='icon-chat'/>}
                        {has_lifestory && <AppSidebarMenuItem link={getDashboardRouterLink('?type=all-posts')} title='All Posts' name={OrgDashboardFilters.ALL_POSTS} iconName='icon-chat'/>}

                        <AppSidebarMenuItem link={getDashboardRouterLink('?type=child-messages')} title='Child Messages' name={OrgDashboardFilters.CHILD_MESSAGES}  iconName='icon-email' />
                        <AppSidebarMenuItem link={getDashboardRouterLink('?type=staff-messages')} title='Staff Messages' name={OrgDashboardFilters.STAFF_MESSAGES}  iconName='icon-email'/>
                        <AppSidebarMenuItem link={getDashboardRouterLink('?type=all-messages')} title='All Messages' name={OrgDashboardFilters.ALL_MESSAGES}  iconName='icon-email'/>

                        <AppSidebarMenuItem link={getDashboardRouterLink('?type=child-logins')} title='Child Logins' name={OrgDashboardFilters.CHILD_LOGINS} iconName='icon-chart'/>
                        <AppSidebarMenuItem link={getDashboardRouterLink('?type=staff-logins')} title='Staff Logins' name={OrgDashboardFilters.STAFF_LOGINS} iconName='icon-chart'/>
                        <AppSidebarMenuItem link={getDashboardRouterLink('?type=all-logins')} title='All Logins' name={OrgDashboardFilters.ALL_LOGINS} iconName='icon-chart'/>
                        {has_lifestory && <AppSidebarMenuItem link={getDashboardRouterLink('?type=child-diary')} title='Child Diary' name={OrgDashboardFilters.CHILD_DIARY} iconName='icon-calendar'/>}
                        <AppSidebarMenuItem link={getDashboardRouterLink('?type=child-age')} title='Child Age' name={OrgDashboardFilters.CHILD_AGE}iconName='icon-user-o'/>
                        <AppSidebarMenuItem link={getDashboardRouterLink('?type=users')} title='Users by Type' name={OrgDashboardFilters.USERS} iconName='icon-family'/>
                    </AppSidebarGroup>
                </ul>

                <ScrollRails />

            </div>

        </div>
    ) ;
}

export default OrgDashAppSidebar;
